// Export all the settings to the global scope
window.shopSettings = {"container_width":"1300px","container_padding":"0 1.5em","container_padding_tablet":"0 1.2em","container_padding_mobile":"0 2em","breakpoint_tablet":"900px","breakpoint_mobile":"600px","bg_color":"#ffffff","content_text_color":"#000000","content_heading_color":"#000000","content_main_color":"#00205b","content_main_color_rgb":"0,120,255","content_second_color":"#7bafd4","content_third_color":"#c7c7c7","content_red_details_color":"#ff0202","fonts_link":"","fonts_query":"@import url(\"https:\/\/use.typekit.net\/ndl3kyr.css\");","body_font":"p22-underground, sans-serif","body_font_weight":"400","body_font_size":"15px","body_font_letter_spacing":"0","body_font_line_height":"170%","heading_font":"adobe-caslon-pro, serif","heading_font_weight":"400","heading_font_style":"normal","heading_font_transform":"none","heading_font_letter_spacing":"0","heading_font_line_height":"120%","font_icons_awesome":false,"font_icons_linear":false,"font_icons_ion":false,"font_icons_drip":false,"font_icons_stroke":false,"font_icons_themify":false,"button_background":"#72a8c3","button_text":"#ffffff","button_border":"0","button_size":"1.2em","button_spacing":"0.005em","button_padding":"1em 1.2em 0.8em","button_radius":"0em","button_transform":"none","button_weight":"500","button_background_hover":"#ffffff","button_text_hover":"#72a8c3","button_border_hover":"0","border_scale_hover":false,"button_background2":"#0089ff","button_text2":"#ffffff","button_border2":"0","button_size2":"1em","button_spacing2":"0.05em","button_padding2":"1em 2em","button_radius2":"0em","button_transform2":"uppercase","button_weight2":"700","button_background_hover2":"#000000","button_text_hover2":"#ffffff","button_border_hover2":"0","border_scale_hover2":false,"button_background3":"#0089ff","button_text3":"#ffffff","button_border3":"0","button_size3":"1em","button_spacing3":"0.05em","button_padding3":"1em 2em","button_radius3":"0em","button_transform3":"uppercase","button_weight3":"700","button_background_hover3":"#000000","button_text_hover3":"#ffffff","button_border_hover3":"0","border_scale_hover3":false,"button_background4":"#0089ff","button_text4":"#ffffff","button_border4":"0","button_size4":"1em","button_spacing4":"0.05em","button_padding4":"1em 2em","button_radius4":"0em","button_transform4":"uppercase","button_weight4":"700","button_background_hover4":"#000000","button_text_hover4":"#ffffff","button_border_hover4":"0","border_scale_hover4":true,"label_text":"#000000","label_size":"1em","label_spacing":"0","label_padding":"1em 0 0.5em","label_transform":"none","label_weight":"400","placeholder_color":"#000000","input_background":"#ffffff","input_text":"#000000","input_border":"1px solid #000","input_size":"1em","input_spacing":"0","input_padding":"1em 1em 0.8em 1em","input_radius":"0em","input_transform":"none","input_weight":"400","input_outline_none":true,"input_background_focus":"#ffffff","input_text_focus":"#000000","input_border_focus":"1px solid #000","mobile_menu_button_color":"rgba(0,0,0,0)","mobile_menu_button_icon":"#000000","mobile_menu_position":"left","mobile_menu_font_size":"1.2em","mobile_menu_bg_color":"#ffffff","mobile_menu_text_color":"#000000","mobile_menu_arrows_color":"#000000","mobile_menu_borders_color":"#979797","mobile_menu_transform":"none","mobile_menu_title_bg_color":"#ffffff","mobile_menu_title_color":"#000000","mobile_menu_title_weight":"400","mobile_menu_title_transform":"none","mega_menu_position":"center","mega_menu_width":"full","mega_menu_1":true,"mega_menu_2":true,"mega_menu_3":true,"allow_quick_view":false,"grid_product_image_behavior":"alternate_image","grid_align":"center","grid_items_per_row":"one-third","grid_items_per_row_medium":"one-half","grid_items_per_row_small":"one-whole","main_image_display":"Both","product_image_switch_onload":false,"product_main_image_effect":"fade","product_thumbs_group_by":"","product_thumbs_group_mode":"4","product_thumbs_slide":"vertical","variants_layout":"dropdown","enable_color_swatches":true,"share_prod_on_twitter":true,"share_prod_on_facebook":true,"share_prod_on_pinterest":true,"show_related_products":true,"related_products_title":"You Might Also Like","show_recently_viewed":false,"recently_viewed_title":"Recently Viewed","3d_model_popup":false,"3d_model_popup_link":"Open PopUp","allow_side_cart":true,"allow_ajax_cart":true,"allow_note":false,"cart_additional_msg":"","cart_return_policy":"","sidecart_position":"right","sidecart_bg_color":"#ffffff","sidecart_text_color":"#000000","sidecart_borders_color":"#dddddd","sidecart_title_bg_color":"#16315b","sidecart_title_color":"#ffffff","sidecart_title_border_bottom":"#16315b","sidecart_title_weight":"500","sidecart_title_transform":"none","shipping_calculator":false,"shipping_calculator_heading":"Shipping Rates Calculator","shipping_calculator_default_country":"United States","shipping_calculator_submit_button_label":"Calculate","shipping_calculator_submit_button_label_disabled":"Calculating...","twitter_link":"","facebook_link":"https:\/\/www.facebook.com\/SignitasJewelry\/","pinterest_link":"https:\/\/www.pinterest.com\/signitasjewelry\/","instagram_link":"https:\/\/www.instagram.com\/signitas\/","linkedin_link":"https:\/\/www.linkedin.com\/company\/signitas-inc.?trk=public_profile_topcard-current-company","youtube_link":"","vimeo_link":"","tumblr_link":"","mailing_link":"","use_klaviyo_form":false,"klaviyo_list_id":"","use_mailchimp_form":false,"mailchimp_domain":"","mailchimp_user":"","mailchimp_id":"","enable_subscription_popup":false,"subscription_first_time":false,"subscription_bg":"\/\/cdn.shopify.com\/s\/files\/1\/0467\/5364\/4698\/files\/couple_600x355_Nav_feature.jpg?v=1787110966","subscription_bg_color":"#ffffff","subscription_text_color":"#000000","subscription_title":"Welcome to Signitas!","subscription_text":"Sign up to receive exclusive updates, offers and access.","subscription_success":"Thank you for Joining!","subscription_success_msg":"Don't forget to check your email to complete your subscription.","gift_card_title":"Here is your [[shop.name]] e-Gift Card!","gift_card_subtitle":"Use this code at checkout to redeem your gift card","pt_show_refine":false,"pt_show_collection_group":false,"pt_show_clear":false,"pt_show_view_all":false,"pt_show_collection_count":false,"pt_show_show_single_group":false,"pt_scroll_filter_group":true,"pt_show_inactive_filters":false,"pt_force_dropdown":true,"pt_hide_headers":false,"pt_float_filters":"true","pt_refine_text":"Refine","pt_clear_text":"clear","pt_view_all_text":"view all","pt_tags_text":"Tags","pt_sort_by_text":"Sort By:","pt_collection_text":"Collection","pt_search_placeholder_text":"search...","pt_mobile_text":"Filter","pt_show_tags_group":false,"pt_show_tags_grouped":false,"pt_show_sort_by_group":true,"pt_sort_position":"bottom","pt_sort_by_dropdown":false,"pt_show_sort_by_checkboxes":false,"pt_sort_manual_text":"Featured","pt_sort_price_asc_text":"Price: Low to High","pt_sort_price_desc_text":"Price: High to Low","pt_sort_title_asc_text":"A-Z","pt_sort_title_desc_text":"Z-A","pt_sort_created_asc_text":"Newest Last","pt_sort_created_desc_text":"Newest","pt_sort_best_selling_text":"Best Selling","color_pt_header_text":"#222","color_pt_header_border":"#ddd","color_pt_header_top_border":"rgba(0,0,0,0)","pt_header_size":18,"pt_header_font_override":false,"pt_header_font":{"error":"json not allowed for this object"},"pt_header_weight":"300","color_pt_links":"#222","color_pt_links_selected":"#333","color_pt_links_hover":"#444","color_pt_counts_color":"#888","pt_links_size":14,"pt_links_font_override":false,"pt_links_font":{"error":"json not allowed for this object"},"pt_links_weight":"300","pt_show_checkboxes":true,"pt_checkbox_style":"0","pt_checkbox_swatch_style":"3","pt_checkbox_primary_color":"#888","pt_checkbox_secondary_color":"#444","pt_checkbox_size":15,"pt_checkbox_size_swatch":25,"pt_checkbox_checkbox_align":"middle","pt_color_swatch_type":"swatch","color_pt_clear_bg":"#eee","color_pt_clear_text":"#222","color_pt_clear_bg_hover":"#ddd","color_pt_clear_text_hover":"#222","color_pt_bg":"rgba(0,0,0,0)","color_pt_bg_border":"rgba(0,0,0,0)","pt_bg_padding":0,"pt_bg_radius":3,"pt_mobile_enable":false,"pt_accordion_enable":false,"pt_accordion_mode":"all","pt_mobile_color":"#222","pt_mobile_max_width":"767px","pt_mobile_vertical":7,"pt_mobile_text_vertical":14,"pt_mobile_font_override":false,"pt_mobile_font":{"error":"json not allowed for this object"},"pt_mobile_size":"","pt_mobile_hide_selected":false,"color_pt_small_box_bg":"#ffffff","color_pt_small_box_bg_hover":"#00a5fd","color_pt_small_box_text_hover":"#ffffff","pt_small_box_radius":3,"pt_small_box_border":true,"pt_small_box_shadow":true,"pt_view_more_enable":false,"pt_view_more_count":10,"pt_view_more_text":"View More...","pt_apply_button_enable":false,"pt_apply_button_text":"Apply","pt_apply_button_color":"#0084ff","pt_apply_button_hover_color":"#0670cf","pt_apply_button_disabled_color":"#cccccc","pt_sticky_enable":false,"pt_sticky_mode":"basic","pt_sticky_selector":".filter-menu","pt_sticky_offset":"25px","pt_sticky_min_width":"767px","pt_ajax_enable":false,"pt_ajax_selector":"#main","pt_ajax_script":";","pt_show_only_on_collections":false,"pt_clear_to_current_collection":false,"pt_desktop_always_show_selected":true,"pt_filter_padding":6,"pt_temporary_disable":false,"checkout_header_image":"","checkout_use_storefront_logo":false,"checkout_logo_image":"shopify:\/\/shop_images\/LOGO_2x_3eb0b6b6-376e-461d-8c23-d6ef5a8b1b4b.png","checkout_logo_position":"left","checkout_logo_size":"large","checkout_body_background_image":"","checkout_body_background_color":"#ffffff","checkout_input_background_color_mode":"white","checkout_sidebar_background_image":"","checkout_sidebar_background_color":"#fafafa","checkout_heading_font":"Helvetica Neue","checkout_body_font":"Helvetica Neue","checkout_accent_color":"#16315c","checkout_button_color":"#16315c","checkout_error_color":"#d93535","cart_item_bg_color":"#f9f9f9","cart_item_border_color":"#ddd","blog_layout":"list","blog_show_recent":true,"blog_show_featured":false,"featured_article_1_show":true,"featured_article_1":"","featured_article_2_show":true,"featured_article_2":"","featured_article_3_show":true,"featured_article_3":"","featured_article_4_show":false,"featured_article_4":"","featured_article_5_show":false,"featured_article_5":"","heading_font_link":"","heading_font_query":"@import url('https:\/\/fonts.googleapis.com\/css?family=Raleway:400,700,900|Roboto:400,700\u0026display=swap');","body_font_link":"","body_font_query":"","gift_card_image":"red","cart_template":"two-columns","cart_items_table":true,"cart_header_table_background":"#000000","cart_header_table_color":"#ffffff","cart_body_table_background":"#f9f9f9","cart_body_table_border":"#e5e5e5","share_prod_on_googleplus":true,"google_link":"https:\/\/google.com","menu_font":"body_font","menu_text_transform":"uppercase","menu_font_size":"1em","menu_letter_spacing":"0.05em","menu_font_weight":"700","dropdown_bg_color":"#ffffff","top_utils_size":"0.9em","top_utils_weight":"400","top_utils_transform":"none","footer_bg_color":"#ffffff","footer_border_color":"#ffffff","content_footer_text_color":"#000000","show_social_footer":true,"plus_american_express":false,"plus_diners_club":false,"plus_discover":false,"plus_jcb":false,"plus_master":false,"plus_paypal":false,"plus_visa":false,"flickr_link":"","github_link":"","body_font_style":"normal","mega_menu_parent_1":"shop","mega_menu_parent_2":"","show_utility_bar":"true","utility_bar_link":"","utility_bar":"Check out our Collections!","utility_bar_color":"#000","utility_bar_text_color":"#fff","utility_bar_text_size":"0.9em","utility_bar_close_color":"#fff","header_behavior":"static","drop_header":"true","over_carousel":"false","header_behavior_mobile":"static","drop_header_mobile":"true","header_color":"#ffffff","header_border_color":"#ffffff","header_text_color":"#000000","show_social_header":"true","show_search_header":"true","show_newsletter_header":"true","search_mailing_bg":"0,0,0,0.8","search_mailing_text":"#ffffff","search_mailing_effect":"fadeInLeft","seo_keywords":"","add_social_links":true,"enable_tracking_codes":true,"fb_tracking_id":"","debug_tracking_events":false,"track_pageview":false,"track_index":false,"track_product":false,"track_collection":false,"track_list_collection":false,"track_cart":false,"track_add_to_cart":false,"track_init_checkout":false,"track_page":false,"track_search":false,"track_newsletter":false,"subscription_layout":"special","subscription_disclaimer":"","enable_promotion_popup":true,"promo_popup_first_time":true,"promo_popup_image":true,"promo_popup_bg_color":"#000000","promo_popup_bg_overlay":"0,0,0,0.4","promo_popup_text_color":"#fff","promo_popup_color":"#0089ff","promo_popup_title":"Join Our Mailing List","promo_popup_promo":"10% Off Your First Order","promo_popup_text":"Be the first to know about new arrivals, sales, special offers \u0026 more!","promo_popup_success":"Thank you for Joining!","promo_popup_promo_code":"Shop now and use promo code \u003cb\u003eFIRSTVISIT\u003c\/b\u003e at checkout for 10% off your first order!","content_placeholder_color":"#7d7d7d","home_show_featured_products":true,"home_featured_products_title":"Featured Products","homepage_collection":"tees","home_featured_products_row":"4","show_instagram_feed":true,"instagram_title":"Follow us on Instagram","instagram_user_id":"1308131391","instagram_access_token":"1308131391.ba4c844.f81ea8272d5f4fc587c198704fe375bd","instagram_items_row":"6","button_color":"#0089ff","secondary_button_color":"#aaa","button_font_size":"1em","featured_article_1_slug":"62559299-phasellus-tellus-magna","featured_article_1_title":"Phasellus Magna","featured_article_1_sub":"by Simplistic","featured_article_2_slug":"","featured_article_2_title":"Mauris Venanatis","featured_article_2_sub":"by Simplistic","featured_article_3_slug":"","featured_article_3_title":"Lorem Ipsum","featured_article_3_sub":"by Simplistic","featured_article_4_slug":"","featured_article_4_title":"","featured_article_4_sub":"","featured_article_5_slug":"","featured_article_5_title":"","featured_article_5_sub":"","checkout_use_header_image":false,"checkout_logo":"checkout_logo.png","checkout_use_body_background_image":false,"checkout_use_sidebar_background_image":false,"alternate_image":true,"show_thumbs_swatches":false,"font_icons_fa":true,"heading_font_icons":"FontAwesome","alternate_blog":true,"promo_popup_only_color":true,"header_style":"1","home_show_collections":true,"home_collections_title":"Browse Collections","show_homepage_banner":false,"homepage_banner_link":"\/collections\/all","homepage_banner":"FREE SHIPPING ON ORDERS OVER $50","homepage_banner_color":"#000000","homepage_banner_text_color":"#fff","homepage_banner_show_image":false,"header_font":"'Raleway', sans-serif","header_font_weight":"400","header_font_style":"normal","header_font_transform":"uppercase","header_font_letter_spacing":"0.07em","content_button_color":"#0089ff","content_header_color":"#ffffff","content_header_border_color":"#ffffff","allow_mini_cart":true,"content_header_border":"#ffffff","show_cartbtn_header":"1","content_fixed_header":true,"show_caption_mobile":true,"checkout_banner_background_color":"#ffffff","checkout_headline":"","checkout_call_to_action_color":"#00c3f1","allow_purchase":false,"mobile_menu_border_top":false,"mobile_menu_border_bottom":false,"enable_mobile_menu":true,"disable_mobile_fixed_header":true,"mobile_menu_color":"#cccccc","mobile_menu_hover_color":"#007dbe","may_like_section":false,"may_like_collection":"lightbulbs","may_like_items_per_row":"4","content_gma_logo":false,"content_wabc_logo":false,"show_product_grid_item_form":true,"customer_layout":"theme","atom_link":"","may_like_three_per_row":"false","may_like_four_per_row":"true","three_per_row":"true","four_per_row":"false","logo_image":"logo.png","content_secondary_color":"#00afdb","may_like":"true","content_bg_color":"#ffffff","btn_color":"#00c3f1","btn_text_color":"#ffffff","btn_hover_color":"#10a9cc","btn_hover_text_color":"#ffffff","body_bg_img":"none","body_bg_alignment":"center","logo_color":"#333333","logo_hover_color":"","cart_bg_color":"#eeeeee","cart_link_color":"#afafaf","cart_link_hover_color":"#00c3f1","cart_divider_color":"#cccccc","nav_font_style":"normal","nav_link_color":"#00c3f1","nav_hover_color":"#282c2e","nav_divider_color":"#dddddd","dropdown_brd_color":"#dddddd","show_right_column":"false","widget_title_color":"#333333","widget_title_font_style":"normal","widget_text_color":"#666666","widget_bg_color":"#ffffff","widget_link_color":"#333333","widget_link_hover_color":"#b3b3b3","widget_divider_color":"#cccccc","textwidget_visible":"false","textwidget_title":"Welcome","textwidget_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean pharetra, ligula non mollis pretium, lectus libero sodales augue, interdum auctor mauris dui non risus. Nulla facilisi. Nunc rutrum diam in elit sagittis eget viverra erat viverra. Morbi imperdiet aliquet libero vel rhoncus. Integer.","show_allcollections_widget":"true","allcollections_title":"Product Categories","show_vendors_widget":"false","vendors_widget_title":"Vendors","show_widget_linklist1":"false","widget_linklist1":"","show_widget_linklist2":"false","widget_linklist2":"","show_widget_linklist3":"false","widget_linklist3":"","show_blog":"true","widget_blog":"frontpage","show_mailing_list":"false","mailing_list_type":"shopify","mailchimp_form_action":"","mailing_list_title":"Newsletter","mailing_list_tagline":"We promise to only send you good things.","grid_header_color":"#707070","grid_header_font_style":"normal","grid_bg_color":"#ffffff","grid_text_color":"#5e5c5c","grid_link_color":"#5e5c5c","grid_link_hover_color":"#5e5c5c","grid_price_color":"#ababab","grid_price_background_color":"#e6e6e6","show_vendor":"false","added_to_cart_bg":"#ffffff","product_price_color":"#a8a8a8","productspg_related_products":"true","productspg_featured_collection":"frontpage","productspg_featured_collection_heading":"","productspg_featured_limit":"24","comment_bg":"#ffffff","comment_text_color":"#666666","comment_author_color":"#333333","comment_date_color":"#cccccc","featured_collection_visible":"false","featured_collection_title":"View Products","featured_collection_name":"frontpage","footer_txt_color":"#999999","footer_link_color":"#999999","footer_link_hover_color":"#a8a8a8","footer_linklist":"footer","show_amex":"true","show_discover":"true","show_visa":"true","show_mastercard":"true","show_maestro":"true","show_cirrus":"true","show_paypal":"true","show_google":"true","cart_header_color":"#ffffff","sale_background_color":"#e8e8e8","sale_text_color":"#000000","content_link_color":"#000000","content_link_hover_color":"#aaaaaa","use_diagonal":"false","diagonal_color":"diagonal-light-grey.png","show_page_on_homepage":"false","home_page":"frontpage","feature_collections_on_homepage":"false","feature_collections_on_homepage_heading":"Shop by categories","use_linklist_for_categories":"false","linklist_for_categories":"","home_featured_product_font_style":"normal","home_featured_collection":"frontpage","home_featured_header_show":"false","show_featured_desc":"true","home_products_collection":"frontpage","home_products_limit":"4","header_search_border_color":"#dddddd","search_icon_color":"black","show_header_search":"false","twitterwidget_visible":"true","twitterwidget_title":"Latest Tweets","twitterwidget_username":"shopify","twitterwidget_numtweets":"4"}

// First tab key listening
window.addEventListener('keydown', function(e){
  if (e.key === 'Tab') { // tab
    document.body.classList.add('user-is-tabbing');
  }
});
document.addEventListener("click", function(){
  document.body.classList.remove('user-is-tabbing');
});

$(function() {
  	/* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  	var oSlideToggle = jQuery.fn.slideToggle;
    jQuery.fn.slideToggle = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.toggle.apply(this, arguments); 
      }else{
      	return oSlideToggle.apply(this, arguments);
      }
    };
    var oSlideDown = jQuery.fn.slideDown;
    jQuery.fn.slideDown = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.show.apply(this, arguments); 
      }else{
      	return oSlideDown.apply(this, arguments);
      }
    };
    var oSlideUp = jQuery.fn.slideUp;
    jQuery.fn.slideUp = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.hide.apply(this, arguments); 
      }else{
      	return oSlideUp.apply(this, arguments);
      }
    };
  	/* End of Reduced Motion */
  
  	jQuery.fn.sortDomElements = (function() {
        return function(comparator) {
            return Array.prototype.sort.call(this, comparator).each(function(i) {
                  this.parentNode.appendChild(this);
            });
        };
    })();
  
  	if(!isMobile.any) {
      $('body').addClass('isNotMobile'); 
    }

  	$(document).on("click", ".quantity-box .minus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          if(input.attr('min')<input.val()) {
          	input.get(0).stepDown();
          	input.change();
          }
        } catch(e) {
          var value = (parseInt(input.val())-1);
          input.val((value>=0 ? value : 0));
          input.change();
        }
  	});
  	$(document).on("click", ".quantity-box .plus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          input.get(0).stepUp();
          input.change();
        } catch(e) {
          var value = (parseInt(input.val())+1);
          input.val(value);
          input.change();
        }
  	});

  	/********* QUICK VIEW *********/
  	$(document).on('click', '.product-item .quick-view-btn', function(){
      var url = $(this).data('url');
      $('#loading-overlay').show();

      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        Simplistic.openModal(data, 'quick-view');

        if (window.BOLD && BOLD.options && BOLD.options.app && typeof BOLD.options.app.boot == 'function') {
          BOLD.options.app.unload();
          BOLD.options.app.boot();
        }
      });

      return false;
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}

    if (shopSettings.allow_ajax_cart) {
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });
      } else {
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            return validateAddCart($(this));
        });
      }

    $(window).scroll($.throttle(15, function(){
      if($(this).scrollTop()<=200) {
        $('.scrollup').removeClass('fadein');
      } else {
        $('.scrollup').addClass('fadein');
      }

      if (shopSettings.drop_header) {
        if( $(this).scrollTop()>=80 ) {
          $('.header-drop').addClass('scroll');
        } else {
          $('.header-drop').removeClass('scroll');
        }
      }

      if( $(this).scrollTop()>=80 ) {
        $('body').addClass('scroll');
      } else {
        $('body').removeClass('scroll');
      }
    }));

    $('.header-drop .main-menu').html($('#header .main-menu').html());
    $('.header-drop .main-menu a').attr({'focusable':'false','tabindex':'-1','aria-hidden':'true'});
  	setupDropdownMenus();  
});

function setupDropdownMenus(){
  var config = {
    over: function () {
      $(this).find('.submenu:first').slideDown();
    }, 
    timeout: 400, 
    out: function () {
      $(this).find('.submenu:first').slideUp();
    }
  };
  $('.main-menu .has-dropdown').hoverIntent(config);

  $(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
    if (e.which == 32) { //Spacebar
      e.preventDefault();
      $(this).next().slideToggle();
    }
    if (e.which == 40) { //Arrow Down
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 38) { //Arrow Up
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
  $(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
    if (e.which == 39) { //Arrow Right
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 37) { //Arrow Left
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initSideCart() {
	$('.header .cart-wrap').click(function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;

    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
        if (window.BOLD && BOLD.common && BOLD.common.eventEmitter 
    && typeof BOLD.common.eventEmitter.emit === 'function'){
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
}
}

function addToCart(form, callback){

var boldForm = document.querySelector('.add-to-cart-form');

	$('#loading-overlay').show();
  	if(modal) modal.close();
  
  	var productJs = form.closest('.initialized').data('productjs');
  	if(productJs) {
    	$(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
    } else {
    	$(document).trigger("addToCart", [form]);
    }
  
	$.ajax({
      type: 'POST',
      url: '/cart/add.js',
      //data: form.serialize(),
data: window.FormData ? new FormData(boldForm) : form.serialize(),
contentType : false,
processData : false,
      dataType: 'json',
      error: addToCartFail,
      success: function(){
        if(productJs) {
          $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
        } else {
          $(document).trigger("addToCartSuccess", [form]);
        }
        if(callback) {
          callback();
        } else {
          addToCartSuccess();
        }
        (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
      },
      cache: false
	});
    (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc(true);
        if (window.BOLD && BOLD.common && BOLD.common.eventEmitter 
    && typeof BOLD.common.eventEmitter.emit === 'function'){
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
}
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

function updateCartDesc(openSideCart){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          $('#loading-overlay').hide();

          var animate = true;
          if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
            animate = false;
          }
          $('#side-cart').remove();
          $('#page').append(data);
          if(modal) modal.close();
          if(openSideCart){
            showSideCart(animate);
          }
      	}
	});
  if (window.BOLD && BOLD.common && BOLD.common.eventEmitter 
    && typeof BOLD.common.eventEmitter.emit === 'function'){
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
}

}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }
  Simplistic.trapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

window.SimplisticJS = function (){
  this.formatMoney = "$ \{\{amount\}\}";
  this.beforeTrapFocus = false;
  
  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    this.beforeTrapFocus = $(':focus');
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    if(this.beforeTrapFocus) {
    	this.beforeTrapFocus.focus();
      	this.beforeTrapFocus = false;
    }

    $(document).off(eventName);
  }
  
  this.handleize = function (str) {
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };
  
  this.reducedMotion = function() {
  	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css) {
    modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css],
      beforeOpen: function() {
        $(".tingle-modal__close").appendTo(".tingle-modal-box__content");
      },
      beforeClose: function() {
    	$(".tingle-modal__close").prependTo(".tingle-modal");
        return true;
      }
    });
    modal.setContent(content);
    modal.open();
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    if(images.length>0) {
      images.each(function(){
        var img = new Image();
        img.onload = loadFunction;
        img.onerror = loadFunction;
        img.src = $(this).attr('src');
      });
    } else {
      callback();
    }
  };
};
window.Simplistic = new SimplisticJS();
